import { api, API_PREFIX } from './client'
import type { LoadSearchHit } from '../../types/api'

/**
 * Load search for the command palette — uses the existing assignments list
 * endpoint's `search` parameter (GET /assignments/loads?search=).
 */
export async function searchLoads(query: string, limit = 8): Promise<LoadSearchHit[]> {
  const q = query.trim()
  if (!q) return []
  const res = await api.get(`${API_PREFIX}/assignments/loads`, { params: { search: q, page: 1, page_size: limit } })
  const d = res.data
  const items: Array<Record<string, unknown>> = Array.isArray(d) ? d : (d?.items ?? d?.loads ?? [])
  return items.map(l => ({
    id: String(l.id ?? l.load_id ?? ''),
    load_number: String(l.load_number ?? l.loadNumber ?? ''),
    status: (l.status as string | undefined) ?? undefined,
    driver_name: (l.driver_name as string | null | undefined) ?? null,
    driver_id: (l.driver_id as string | null | undefined) ?? null,
    origin: (l.origin_facility_name as string | null | undefined) ?? (l.origin as string | null | undefined) ?? null,
    destination: (l.destination_facility_name as string | null | undefined) ?? (l.destination as string | null | undefined) ?? null,
    planned_start: (l.planned_start as string | null | undefined) ?? null,
  })).filter(h => h.id)
}
